import { config } from '@app/config';
import { useAuth } from './useAuth';

/** Returns true when the logged-in user is the automated testing account. */
export function useIsTestingUser(): boolean {
  const { user } = useAuth();

  return user.email === config.testingUserEmail;
}
